import Loading from 'components/Loading'
import React from 'react'

const Google: React.FC = () => {
  return (
    <Loading />
  )
}

export default Google